// extracted by mini-css-extract-plugin
export default {"instagramIcon":"E6JXR7"};